import { Product, ProductType } from "@core/types";

export const calculateDiscount = (
  type: Product["type"],
  onSale: Product["onSale"],
  price: Product["price"],
  regularPrice: Product["regularPrice"],
  priceHtml: Product["priceHtml"]
): number | null => {
  if (
    !onSale ||
    regularPrice === undefined ||
    (type !== ProductType.VARIABLE && regularPrice?.length === 0 && price?.length === 0)
  ) {
    return null;
  }

  // TODO:Refactor: Абдул-Малик, сильно не бей за такое
  if (type === ProductType.VARIABLE && priceHtml) {
    const priceHtmlRegex = /<ins>.*?<bdi>(.*?)<\/bdi>.*?<del>.*?<bdi>(.*?)<\/bdi>/;
    const matches = priceHtml.match(priceHtmlRegex);

    if (matches && matches.length >= 3) {
      const [, salePriceStrMatch, regularPriceStrMatch] = matches;
      const salePriceIndex = salePriceStrMatch.indexOf("</span>");
      const regularPriceIndex = regularPriceStrMatch.indexOf("</span>");

      if (salePriceIndex !== -1 && regularPriceIndex !== -1) {
        const len = "</span>".length;
        const salePriceStr = salePriceStrMatch.substring(salePriceIndex + len);
        const regularPriceStr = regularPriceStrMatch.substring(regularPriceIndex + len);

        if (regularPriceStr && salePriceStr) {
          const percent =
            ((parseFloat(regularPriceStr) - parseFloat(salePriceStr)) / parseFloat(regularPriceStr)) * 100;
          return parseFloat(percent.toFixed(0));
        }
      }
    }

    return null;
  }

  const percent = ((parseFloat(regularPrice) - parseFloat(price)) / parseFloat(regularPrice)) * 100;

  if (isNaN(percent)) return null;

  return percent;
};
